import React from 'react';
import Settings from '../../../Settings';
import DealDetailScreen from './DealDetailScreen';
import {
  markSingleMessageAsRead,
  NotificationMessageParams,
} from 'src/redux/thunks/notificationThunks/messageRead';
import Deal from 'src/models/Moblico/Deal';
import {compose} from 'redux';
import {AppDispatch, RootState} from '../../../redux/store';
import {withForwardedNavigationParams} from 'react-navigation-props-mapper';
import {connect} from 'react-redux';
import DealDetailCanteenScreen from './DealDetailCanteenScreen';
import {
  withGlobalize,
  WithGlobalizeProps,
} from '../../../i18n/HOC/withGlobalize';
import {StackNavigationProp} from '@react-navigation/stack';
import {AppRoutesParamList} from './types';
import {RouteProp} from '@react-navigation/native';

type DealDetailScreenProps = WithGlobalizeProps & {
  deal: Deal;
  navigation: StackNavigationProp<AppRoutesParamList, 'DealDetail'>;
  route: RouteProp<AppRoutesParamList, 'DealDetail'>;
  loading: boolean;
  markMessageAsRead(params: NotificationMessageParams): void;
};

function DealDetailScreenFactory(props: DealDetailScreenProps) {
  if (Settings.isCanteen()) {
    return <DealDetailCanteenScreen {...props} />;
  } else {
    return <DealDetailScreen {...props} />;
  }
}

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  markMessageAsRead: (params) => dispatch(markSingleMessageAsRead(params)),
});

const mapStateToProps = (state: RootState) => ({
  loading: state.snack.loading,
});

export default compose(
  withForwardedNavigationParams<DealDetailScreenProps>(),
  withGlobalize,
  connect(mapStateToProps, mapDispatchToProps),
)(DealDetailScreenFactory);
